module.exports = __webpack_public_path__ + "static/loading_2-d334ccf8f3ae4a13dfc83f8e5f844e79.gif";